module.exports = __webpack_public_path__ + "img/8.4bca325c.jpg";